import { LI_COINS, LI_COINS_LOADING, LI_COMPANIES, LI_COMPANIES_LOADING, LI_PROJECTS_BY_COMPANY_RESET, LI_PROJECTS_BY_COMPANY, LI_BILLS_BY_FAMILY, LI_PAYMENTS_TYPES_LIST, LI_REQUIREMENTS_ORDER_LIST, LI_BILLS_BY_BUYER, LI_ORDERS_SERVE, LI_ACCUMULATED_BY_SUPPLIER_PURCHASES, LI_PERCENTAGE_BY_ORDER_REQUEST, CYCLE_BY_PAYMENT_TYPE, LI_BILLS_BY_FAMILY_ELEMENTS, LI_BILLS_BY_FAMILY_RESET, LI_CYCLE_BY_PAYMENT_TYPE_ELEMENTS, LI_ELEMENTS_RESET, LI_PERCENTAGE_BY_ORDER_ELEMENTS, LI_ACCUMULATED_BY_PROVIDER_PURCHASES_ELEMENTS, LI_PERCENTAGE_ATTENDED_ORDERS_ELEMENTS, LI_PERCENTAGE_PRODUCTION_BY_BUYER_ELEMENTS, LI_PERCENTAGE_REQUIREMENT_NUMBERS_ELEMENTS, LI_BILLS_DETAILS_ELEMENTS_TWO, LI_BUYORDER_DATA, LI_BUYORDER_RESET, LI_BUYORDER_CHANGE, LI_BUYORDER_DETAILS, LI_BUYORDER_NOTEPAD_UPDATE, LI_BILLS_BY_PC, LI_BILLS_BY_PC_RESET, LI_BILLS_BY_PC_SELECTED_ITEM, LI_BILLS_BY_PC_SELECTED_ITEM_RESET, LI_BUYORDER_DETAIL_ORDER, LI_BUYORDER_APPROVALS, LI_BUYORDER_STORE, LI_BUYORDER_TO_PAY, LI_BILLS_BY_PC_SELECTED_BILLS_RESET, LI_BILLS_BY_PC_SELECTED_BILLS, LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD_RESET, LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD, LI_BILLS_BY_PC_GENERAL_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD_RESET, LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD, LI_BILLS_BY_PC_GENERAL, LI_BILLS_BY_PC_GENERAL_ELEMENTS, LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO, LI_ELEMENTS_TWO_RESET } from "../constants";
import { cleanDuplicates } from "../utils/data";

const initialState = {
	coinsLoading: false,
	coins: [],
	companiesLoading: false,
	companies: [],
	projectsByCompanies: [],
	projectsByCompaniesParts: [],
	projectsByCompaniesLoading: true,
	billByGroup: [],
	elements: [],
	elementsTotalItems: 0,
	purchaseOrderList: [],
	billsByBuyer: [],
	ordersServe: [],
	accumulatedBySupplierPurchases: [],
	percentageByOrder: [],
	cicleByPaymentType: [],
	elementsTwo: [],
	elementsTotalItemsTwo: 0,
	buyOrderData: null,
	buyOrderAccumulated: [],
	buyOrderAccumulatedTotal: "",
	buyOrderDetailOrder: [],
	buyOrderApprovalData: [],
	buyOrderStoreData: [],
	buyOrderToPayData: [],
	billsByPC: [],
	billsByPCSelectedItem: [],
	billsByPCSpend: [],
	billsByPCSpendByPeriod: [],

	billsByPCGeneral: [],
	billsByPCGeneralSelectedItem: [],
	billsByPCGeneralSpend: [],
	billsByPCGeneralSpendByPeriod: [],
};
// eslint-disable-next-line
export default (state = initialState, {type, payload}) => {
	switch (type) {
		case LI_COINS:
			return {
				...state,
				coins: payload.data,
			};
		case LI_COINS_LOADING:
			return {
				...state,
				coinsLoading: true,
			};
		case LI_COMPANIES:
			return {
				...state,
				companies: payload.data,
			};
		case LI_COMPANIES_LOADING:
			return {
				...state,
				companiesLoading: true,
			};
		case LI_PROJECTS_BY_COMPANY:
			const projectsByCompaniesParts = [...state.projectsByCompaniesParts];
			if (projectsByCompaniesParts.includes(payload.part)) {
				return state;
			}
			projectsByCompaniesParts.push(payload.part);
			return {
				...state,
				projectsByCompanies: cleanDuplicates(
					[
						...state.projectsByCompanies, 
						...payload.data
					], 
					['CodProyecto', 'CodProyectoVector']
				),
				projectsByCompaniesLoading: projectsByCompaniesParts.length !== payload.count,
				projectsByCompaniesParts,
			};
		case LI_PROJECTS_BY_COMPANY_RESET:
			return {
				...state,
				projectsByCompanies: [],
				projectsByCompaniesLoading: false,
				projectsByCompaniesParts: [],
			};
		case LI_BILLS_BY_FAMILY_RESET:
			return {
				...state,
				billByGroup: [],
			};
		case LI_BILLS_BY_FAMILY:
			return {
				...state,
				billByGroup: payload.data.map(i => ({
					...i,
					id: i.CodInsumoN1 || i.CodInsumoN2 || i.CodInsumoN3,
					description: i.DescripcionN1 || i.DescripcionN2 || i.DescripcionN3 || `Sin Familia`,
					SaldoPEN: i.CostoPEN,
					SaldoUSD: i.CostoUSD,
				})),
			};
		case LI_ELEMENTS_RESET:
			return {
				...state,
				elements: [],
				elementsTotalItems: 0,
			};
		case LI_ELEMENTS_TWO_RESET:
			return {
				...state,
				elementsTwo: [],
				elementsTotalItemsTwo: 0,
			};
		case LI_BILLS_BY_FAMILY_ELEMENTS:
			let bbfe = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'CodInsumo',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				bbfe.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return bbfe;

		case LI_PAYMENTS_TYPES_LIST:
			return {
				...state,
				// billByGroup: payload.data,
			};
		case LI_REQUIREMENTS_ORDER_LIST:
			return {
				...state,
				purchaseOrderList: payload.data,
			};
		case LI_BILLS_BY_BUYER:
			return {
				...state,
				billsByBuyer: payload.data,
			};
		case LI_ORDERS_SERVE:
			return {
				...state,
				ordersServe: payload.data,
			};
		case LI_ACCUMULATED_BY_SUPPLIER_PURCHASES:
			return {
				...state,
				accumulatedBySupplierPurchases: payload.data,
			};
		case LI_PERCENTAGE_BY_ORDER_REQUEST:
			return {
				...state,
				percentageByOrder: payload.data,
			};
		case CYCLE_BY_PAYMENT_TYPE:
			return {
				...state,
				cicleByPaymentType: payload.data,
			};
		case LI_CYCLE_BY_PAYMENT_TYPE_ELEMENTS:
			let cbpte = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'NroOrden',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				cbpte.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return cbpte;
		case LI_PERCENTAGE_BY_ORDER_ELEMENTS:
			let pboe = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'CodOrden',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				pboe.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return pboe;
		case LI_ACCUMULATED_BY_PROVIDER_PURCHASES_ELEMENTS:
			let abpp = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'CodInsumo',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				abpp.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return abpp;
		case LI_PERCENTAGE_ATTENDED_ORDERS_ELEMENTS:
			let pao = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'NroNPR',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				pao.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return pao;
		case LI_PERCENTAGE_PRODUCTION_BY_BUYER_ELEMENTS:
			let ppbb = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'NroOrden',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				ppbb.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return ppbb;
		case LI_PERCENTAGE_REQUIREMENT_NUMBERS_ELEMENTS:
			let prn = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'NroNPR',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				prn.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return prn;
		case LI_BILLS_DETAILS_ELEMENTS_TWO:
			let bdet = {
				...state,
				elementsTwo: cleanDuplicates(
					[
						...state.elementsTwo, 
						...payload.data
					], 
					'NroOrden',
					true,
				),
			}
			if (!state.elementsTotalItemsTwo) {
				bdet.elementsTotalItemsTwo = payload.OutputValue?.split("/")[1]
			}
			return bdet;
		case LI_BUYORDER_RESET:
			return {
				...state,
				buyOrderData: null,
				buyOrderAccumulated: [],
				buyOrderAccumulatedTotal: "",
				buyOrderDetailOrder: [],
				buyOrderApprovalData: [],
				buyOrderStoreData: [],
				buyOrderToPayData: [],
			}
		case LI_BUYORDER_DATA:
			return {
				...state,
				buyOrderData: payload.data[0],
			}
		case LI_BUYORDER_DETAILS:
			return {
				...state,
				buyOrderAccumulated: cleanDuplicates(
					[
						...state.buyOrderAccumulated, 
						...payload.data
					], 
					['CodInsumo', 'Linea'],
					true
				).sort((a, b) => a.Linea - b.Linea),
				buyOrderAccumulatedTotal: payload.OutputValue
			}
		case LI_BUYORDER_APPROVALS:
			return {
				...state,
				buyOrderApprovalData: cleanDuplicates(
					[
						...state.buyOrderApprovalData, 
						...payload.data
					], 
					'CodIdentificador',
					true
				).sort((a, b) => a.CodIdentificador - b.CodIdentificador),
			}
		case LI_BUYORDER_STORE:
			return {
				...state,
				buyOrderStoreData: cleanDuplicates(
					[
						...state.buyOrderStoreData, 
						...payload.data
					], 
					'Linea',
					true
				).sort((a, b) => a.Linea - b.Linea),
			}
		case LI_BUYORDER_TO_PAY:
			return {
				...state,
				buyOrderToPayData: cleanDuplicates(
					[
						...state.buyOrderToPayData, 
						...payload.data
					], 
					'CodDocumento',
					true
				).sort((a, b) => a.CodDocumento - b.CodDocumento),
			}
		case LI_BUYORDER_DETAIL_ORDER:
			return {
				...state,
				buyOrderDetailOrder: cleanDuplicates(
					[
						...state.buyOrderDetailOrder, 
						...payload.data
					], 
					'NroOCDP',
					true
				)
			}
		case LI_BUYORDER_NOTEPAD_UPDATE:
		case LI_BUYORDER_CHANGE:
			return state

		case LI_BILLS_BY_PC_RESET:
			return {
				...state,
				billsByPC : [],
			}

		case LI_BILLS_BY_PC:
			return {
				...state,
				billsByPC: cleanDuplicates(
					[
						...state.billsByPC, 
						...payload.data.map(i => ({
							...i, 
							id: i.CodPartidaDeControlN1 || i.CodPartidaDeControlN2 || i.CodPartidaDeControlN3,
							description: i.DescripcionN1 || i.DescripcionN2 || i.DescripcionN3 || `Sin Familia`,
							SaldoPEN:  i.CostoPEN,
							SaldoUSD: i.CostoUSD,
						}))
					], 
					['id'],
				).sort((a, b) => Math.abs(b.SaldoPEN) - Math.abs(a.SaldoPEN)),
			}
		case LI_BILLS_BY_PC_SELECTED_ITEM_RESET:
			return {
				...state,
				billsByPCSelectedItem : [],
			}
		case LI_BILLS_BY_PC_SELECTED_ITEM:
			return {
				...state,
				billsByPCSelectedItem : payload.data,
			}
		case LI_BILLS_BY_PC_SELECTED_BILLS_RESET:
			return {
				...state,
				billsByPCSpend : [],
			}
		case LI_BILLS_BY_PC_SELECTED_BILLS:
			return {
				...state,
				billsByPCSpend: cleanDuplicates(
					[
						...state.billsByPCSpend, 
						...payload.data.map(i => ({
							...i, 
							id: i.CodInsumoN1 || i.CodInsumoN2 || i.CodInsumoN3,							
							description: i.DescripcionN1 || i.DescripcionN2 || i.DescripcionN3 || `Sin Familia`,
							SaldoPEN: i.CostoPEN,
							SaldoUSD: i.CostoUSD,
						}))
					], 
					['id'],
				).sort((a, b) => Math.abs(b.SaldoPEN) - Math.abs(a.SaldoPEN)),
			}
		case LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD_RESET:
			return {
				...state,
				billsByPCSpendByPeriod : [],
			}
		case LI_BILLS_BY_PC_SELECTED_BILLS_BY_PERIOD:
			return {
				...state,
				billsByPCSpendByPeriod : payload.data,
			}

		case LI_BILLS_BY_PC_GENERAL_RESET:
			return {
				...state,
				billsByPCGeneral : [],
			}

		case LI_BILLS_BY_PC_GENERAL:
			return {
				...state,
				billsByPCGeneral: cleanDuplicates(
					[
						...state.billsByPCGeneral, 
						...payload.data.map(i => ({
							...i, 
							id: i.CodPCG1 || i.CodPCG2 || i.CodPCG3 || i.CodPCG4,
							description: i.DesPCG1 || i.DesPCG2 || i.DesPCG3 || i.DesPCG4 || `Sin Familia`,
							SaldoPEN:  i.CostoPEN,
							SaldoUSD: i.CostoUSD,
						}))
					], 
					['id'],
				).sort((a, b) => Math.abs(b.SaldoPEN) - Math.abs(a.SaldoPEN)),
			}
		case LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM_RESET:
			return {
				...state,
				billsByPCGeneralSelectedItem : [],
			}
		case LI_BILLS_BY_PC_GENERAL_SELECTED_ITEM:
			return {
				...state,
				billsByPCGeneralSelectedItem : payload.data,
			}
		case LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_RESET:
			return {
				...state,
				billsByPCGeneralSpend : [],
			}
		case LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS:
			console.log('LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS', payload)
			return {
				...state,
				billsByPCGeneralSpend: cleanDuplicates(
					[
						...state.billsByPCGeneralSpend, 
						...payload.data.map(i => ({
							...i, 
							id: i.CodInsumoN1 || i.CodInsumoN2 || i.CodInsumoN3,
							description: i.DescripcionN1 || i.DescripcionN2 || i.DescripcionN3 || `Sin Familia`,
						}))
					], 
					['id'],
					true
				).sort((a, b) => Math.abs(b.CostoPEN) - Math.abs(a.CostoPEN)),
			}
		case LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD_RESET:
			return {
				...state,
				billsByPCGeneralSpendByPeriod : [],
			}
		case LI_BILLS_BY_PC_GENERAL_SELECTED_BILLS_BY_PERIOD:
			return {
				...state,
				billsByPCGeneralSpendByPeriod : payload.data,
			}
		case LI_BILLS_BY_PC_GENERAL_ELEMENTS:
			let lbbpge = {
				...state,
				elements: cleanDuplicates(
					[
						...state.elements, 
						...payload.data
					], 
					'CodInsumo',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				lbbpge.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return lbbpge;
		case LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO:
			console.log('LI_BILLS_BY_PC_GENERAL_ELEMENTS_TWO', payload)
			let lbbpget = {
				...state,
				elementsTwo: cleanDuplicates(
					[
						...state.elementsTwo, 
						...payload.data
					], 
					'NroOrden',
					true,
				),
			}
			if (!state.elementsTotalItems) {
				lbbpget.elementsTotalItems = payload.OutputValue?.split("/")[1]
			}
			return lbbpget;

		default:
			return state;
	}
};
